<template>
  <div class="pagination wrapper flex justify-end">
    <button
      v-if="totalPages > 4 && currentPage > 3"
      class="min-w-[32px] h-8 px-1 border border-gray-400 hover:bg-gray-100"
      @click="emit('go-to-page', currentPage - 1)"
    >
      &lt;
    </button>

    <template
      v-for="page in totalPages"
      :key="`pagination-${page}`"
    >
      <button
        v-if="page >= startShownPages && page <= endShownPages"
        class="min-w-[32px] h-8 px-1 border border-gray-400 hover:bg-gray-100"
        :class="{
          'bg bg-gray-300 text-black font-semibold': page === currentPage,
          'text-gray-400': page !== currentPage
        }"
        @click="emit('go-to-page', page)"
      >
        {{ page }}
      </button>
    </template>

    <button
      v-if="totalPages > 4 && currentPage < totalPages - 2"
      class="min-w-[32px] h-8 px-1 border border-gray-400 hover:bg-gray-100"
      @click="emit('go-to-page', currentPage + 1)"
    >
      &gt;
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  totalPages: number,
  currentPage: number,
}>();
const emit = defineEmits<{
  (e: 'go-to-page', value: number): void
}>();

const startShownPages = computed<number>(() => {
  if (props.totalPages <= 4 || props.currentPage <= 3) {
    return 1;
  }

  if (props.currentPage + 2 > props.totalPages) {
    return props.totalPages - 4;
  }

  return props.currentPage - 2;
});

const endShownPages = computed<number>(() => {
  if (props.totalPages <= 4 || startShownPages.value + 4 > props.totalPages) {
    return props.totalPages;
  }

  return startShownPages.value + 4;
});
</script>

<style scoped>

</style>
